<script>
export default {
    data() {
        return {
            message:"Hello from your controller."
        }
    },
}
</script>